import React from 'react';
import { Accordion, AccordionSummary, AccordionDetails, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import OwnershipGraph from '../../components/OwnershipGraph/OwnershipGraph';

interface CompanyOwnershipGraphProps {
  companyId: string | undefined;
}

const CompanyOwnershipGraph: React.FC<CompanyOwnershipGraphProps> = ({ companyId }) => (
  <Accordion defaultExpanded={false} sx={{ mb: 3 }}>
    <AccordionSummary
      expandIcon={<ExpandMoreIcon />}
      sx={{
        bgcolor: 'primary.main',
        color: 'white',
        '&:hover': { bgcolor: 'primary.dark' },
        '& .MuiAccordionSummary-expandIconWrapper': { color: 'white' },
      }}
    >
      <Typography variant="h6" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <AccountTreeIcon />
        Ownership Structure Graph
      </Typography>
    </AccordionSummary>
    <AccordionDetails sx={{ p: 3 }}>
      <OwnershipGraph companyId={companyId} />
    </AccordionDetails>
  </Accordion>
);

export default CompanyOwnershipGraph;
